import DarkPieces from '../images/dark_icon128.png';
import LightPieces from '../images/light_icon128.png';
import FirePieces from '../images/fire_icon128.png';
import IcePieces from '../images/ice_icon128.png';
import ThunderPieces from '../images/thunder_icon128.png';

const PuzzlePieces = [
    DarkPieces,
    LightPieces,
    FirePieces,
    IcePieces,
    ThunderPieces
]

export { PuzzlePieces };